/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function () {
  // ADA fix for carousel
	jQuery('.kt-blocks-carousel-init').attr('aria-label', 'Carousel');

  // "Read More" Functionality
	var instance = [ '1', '2', '3', '4' ];
	jQuery.each( instance, function( i, val ) {
		jQuery('.toggle-' + val).click(function(e){
			e.preventDefault();
			jQuery('.showHide-' + val).slideToggle();
			jQuery(this).text( jQuery(this).text() == 'Read More' ? "Read Less" : "Read More");
		});
	});

  //ADA fixes
  jQuery('.post-18').first().attr('id', 'post-18-top');
  jQuery('.team-members').first().attr('id', 'team-members');
  jQuery('.third-archived-post-section').first().attr('id', 'article-id-1');
  jQuery('.third-archived-post-section:eq(1)').attr('id', 'article-id-2');
  jQuery('.third-archived-post-section:eq(2)').attr('id', 'article-id-3');
  jQuery('a.green-button:eq(0)').attr('aria-label', 'first link to recent posts');
  jQuery('select#filter').attr('aria-label', 'user select box for user type');
  jQuery('select#type').attr('aria-label', 'user select box for user type');
  jQuery('select#qm-editor-select').attr('aria-label', 'user select box for user type');
  jQuery('.qm-title-heading select').attr('aria-label', 'user select box for user type');
  jQuery('iframe[src*="https://bid.g.doubleclick.net"]').attr('title', 'tracking pixel');

  // Homepage Emergency Text
  jQuery(".emergency-body").hide();
  jQuery(".emergency-toggle").click(function () {
    jQuery(this).text(jQuery(this).text() === "Open Article +" ? "Close Article -" : "Open Article +");
    jQuery(".emergency-body").slideToggle(900);
  });

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
    function () {
      if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
        jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
      } else {
        jQuery(this).wrap("<div class='responsive-embed'/>");
      }
    }
  );

  // OLD JAVASCRIPT

  jQuery('[role="menu-item"], [role="menuitem"]').on(
    'focus.aria  mouseenter.aria',
    '[aria-haspopup="true"]',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', true);
    }
  );

  // Properly update the ARIA states on blur (keyboard) and mouse out events
  jQuery('[role="menu-item"], [role="menuitem"]').on(
    'blur.aria  mouseleave.aria',
    '[aria-haspopup="true"]',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', false);
    }
  );
  jQuery('[role="menubar"], [role="menuitem"]').on(
    'focus.aria  mouseenter.aria',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', true);
    }
  );

  // Properly update the ARIA states on blur (keyboard) and mouse out events
  jQuery('[role="menubar"], [role="menuitem"]').on(
    'blur.aria  mouseleave.aria',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', false);
    }
  );
  // modal for button
  //data-toggle="exampleModal8"

  jQuery('.mobile-menu').attr('tabindex', '-1');

  jQuery('.ui-datepicker-month').attr('aria-label', 'month dropdown selector');
  jQuery('.ui-datepicker-year').attr('aria-label', 'year dropdown selector');
  const tabs = document.querySelectorAll('[role="tab"]').children;
  const tabList = document.querySelector('[role="tablist"]');
  const tabpanel = document.querySelector('[role="tabpanel"]');
  // const menuitem = document.querySelector('[role="menubar"]').children;

  jQuery('nav#navTopBar > ul', 'nav#mobile-menu > ul').attr('role', 'menubar');
  jQuery('nav#navTopBar > ul > li').attr('role', 'none');
  jQuery('nav#navTopBar > ul > li.menu-item-has-children').removeAttr(
    'aria-haspopup aria-expanded aria-label'
  );
  jQuery('nav#navTopBar > ul > li > a').attr('role', 'menuitem');

  jQuery('nav#mobile-menu ul.offcanvas-menu').removeAttr('role', 'menu');
  jQuery('nav#mobile-menu ul.offcanvas-menu').attr('role', 'tablist');
  jQuery('nav#mobile-menu > ul > li').attr('role', 'none');
  jQuery('nav#mobile-menu > ul > li.menu-item-has-children').removeAttr(
    'aria-haspopup aria-expanded aria-label aria-controls'
  );

  //make sure book an inspection buttons have correct green
  jQuery(".kt-btn-wrap a:contains('Book An Inspection')").css('background-color', '#7ac143');

  // New JS
  var links = document.querySelectorAll('a.button');
  // console.log(links);
  for (var i = 0, len = links.length; i < len; i++) {
    links[i].addEventListener(
      'click',
      function (e) {
        var targetEl = e.target;
        var inkEl = targetEl.querySelector('.ink');

        if (inkEl) {
          inkEl.classList.remove('animate');
        } else {
          inkEl = document.createElement('span');
          inkEl.classList.add('ink');
          inkEl.style.width = inkEl.style.height =
            Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px';
          targetEl.appendChild(inkEl);
        }

        inkEl.style.left = e.offsetX - inkEl.offsetWidth / 2 + 'px';
        inkEl.style.top = e.offsetY - inkEl.offsetHeight / 2 + 'px';
        inkEl.classList.add('animate');
      },
      false
    );
  }

  // Correct way to console log menu interactions
  /*
  $(document).on('show.zf.dropdownmenu', function(ev, $el) {
      console.log('open');
  });
  */

  // END DEFAULT SCRIPT

  //ADA Updates
  jQuery('.submenu').removeAttr('role');
  jQuery('.menu-item').attr('aria-selected', 'true');
  jQuery('.menu-item').attr('aria-expanded', 'true');
  jQuery('.menu-item').removeAttr('role');
  jQuery('.pins_image').attr('alt', 'info icon');
  jQuery('.images_wrap > img').attr('alt', 'house');
  jQuery('.focus-image > img').attr('alt', 'headshot');
  if (jQuery('.acf-headshot').is(':empty')) {
    jQuery(".acf-headshot").prev().css("display", "block");
  } else {
    jQuery(".acf-headshot").prev().css("display", "none");
  }

  //Booking Tip
  jQuery("#close-tip").click(function () {
    jQuery("#book-tip").hide();
    jQuery('#inspection-form-spacer').hide();
    jQuery("#topModalSection").css('margin-top', '0');
    jQuery("#close-inspection-form").css('margin-top', '0');
  });

  //BEGIN HOTSPOT HOME
  var element = document.querySelector(`div.wrap_svl_center`);
  if (typeof element != 'undefined' && element != null) {
    var removeActive = document.getElementsByClassName('drag_element');
    for (var i = 0; i < removeActive.length; i++) {
      (function (index) {
        removeActive[index].addEventListener('click', function () {
          var remove = document.getElementsByClassName('serviceContainer');
          for (var i = 0; i < remove.length; i++) {
            remove[i].classList.remove('active');
            console.log(remove[i].className);
          }
        });
      })(i);
    }
    //Exterior
    document.getElementById('pin1').addEventListener('click', function () {
      var element = document.getElementsByClassName('roofsAttics');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
    document.getElementById('pin2').addEventListener('click', function () {
      var element = document.getElementsByClassName('gutterDrainage');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
    document.getElementById('pin3').addEventListener('click', function () {
      var element = document.getElementsByClassName('porchDeck');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
    document.getElementById('pin4').addEventListener('click', function () {
      var element = document.getElementsByClassName('structuralFoundation');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
    // Interior **************************************
    document.getElementById('pin5').addEventListener('click', function () {
      var element = document.getElementsByClassName('electrical');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
    document.getElementById('pin6').addEventListener('click', function () {
      var element = document.getElementsByClassName('wallsFloors');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
    document.getElementById('pin7').addEventListener('click', function () {
      var element = document.getElementsByClassName('waterHeaters');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
    document.getElementById('pin8').addEventListener('click', function () {
      var element = document.getElementsByClassName('plumbing');
      for (var x = 0; x < element.length; x++) {
        element[x].classList.add('active');
        console.log(element[x].className);
      }
    });
  }

  // BEGIN STICKY
  var element = document.querySelector(`div#stickThis`);
  if (typeof element != 'undefined' && element != null) {
    window.onscroll = function () {
      stickFunction();
    };

    // Get the header
    var header = document.getElementById('stickThis');

    // Get the offset position of the navbar
    var fixstop = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function stickFunction() {
      if (window.scrollY > 687) {
        header.classList.add('fix-stop');
      } else {
        header.classList.remove('fix-stop');
      }
    }
  }

  //BEGIN VIDEO HERO
  var videoElement = document.querySelector(`div#videoHero`);
  if (typeof videoElement != 'undefined' && videoElement != null) {
    document
      .getElementsByClassName('video-start')[0]
      .setAttribute('id', 'videoButton');

    document
      .getElementsByClassName('kb-blocks-bg-video')[0]
      .setAttribute('id', 'homeBuyerVideo');

    document
      .getElementsByClassName('kt-modal-overlay')[0]
      .setAttribute('id', 'ktModalOverlay');

    var vid = document.getElementById('homeBuyerVideo');

    function pauseVid() {
      vid.pause();
    }

    function playVid() {
      vid.play();
    }

    document
      .getElementById('ktModalOverlay')
      .addEventListener('click', function () {
        vid.play();
      });

    document.getElementById('videoButton').addEventListener('click', function () {
      vid.pause();
    });
  }

  //BEGIN STICKY SIDEBAR
  var sideElement = document.querySelector(`div.find-inspector-sticky`);
  // console.log(sideElement);
  if (typeof sideElement != 'undefined' && sideElement != null) {
    function sticky_relocate_2() {
      // https://stackoverflow.com/questions/57525424/how-do-i-add-and-remove-class-while-scrolling-past-an-element
      var window_top = jQuery(window).scrollTop();
      var div_top = jQuery('.find-inspector-sticky').offset().top - 156;

      if (window_top > div_top) {
        jQuery('.find-inspector-sticky .kt-inside-inner-col').addClass(
          'stickyyyyy'
        );
      }
      //if window top reaches the limit removed class
      if (window_top > jQuery('#footerReadyCta').position().top - 700) {
        jQuery('.find-inspector-sticky .kt-inside-inner-col').removeClass('stickyyyyy');
      }
      // console.log(div_top);
    }

    jQuery(window).scroll(sticky_relocate_2);

    window.onscroll = function () {
      newStickyFunction();
    };

    // Get the header
    var mainHeader = document.getElementById('mainHeader');
    console.log(mainHeader);

    // Get the offset position of the navbar
    var fixstop = mainHeader.offsetTop;
    console.log(fixstop);

    document
      .getElementsByClassName('find-inspector-sticky')[0]
      .setAttribute('id', 'stickSide');

    var sidebarStuck = document.getElementById('stickSide').children[0];
    console.log(sidebarStuck);

    var footerRelief = document.getElementById('footerReadyCta');
    console.log(footerRelief);

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function newStickyFunction() {
      if (window.scrollY > 342) {
        sidebarStuck.classList.add('set-position');
      } else {
        sidebarStuck.classList.remove('set-position');
      }
    }
  }

  //book an inspector form conditional logic not working properly on zees-fix
  jQuery('#field_6_27').hide();
  jQuery('#field_6_29').hide();

  jQuery('#field_6_26').on('change', function () {
    console.log('change worked');
    var target = jQuery('#input_6_26').val();
    if (target == "Realtor") {
      jQuery('#field_6_27').show();
      jQuery('#field_6_29').show();
    } else {
      jQuery('#field_6_27').hide();
      jQuery('#field_6_29').hide();
    }
  })

  // For static booking page, show form
  jQuery('#on-page-form > #gform_wrapper_6').show();
});

// ADA fixes
jQuery(window).bind("load", function () {
  // forces iframe manipulation
  jQuery('#g-recaptcha-response-2').attr('aria-label', 'input field for recaptcha');
  jQuery('#g-recaptcha-response-1').attr('aria-label', 'input field for recaptcha');
  jQuery('#g-recaptcha-response').attr('aria-label', 'input field for recaptcha');
  let uniqueNum = 0;
  jQuery(".entry-content").find("a").each(function () {
    jQuery(this).attr('aria-label', ('Link to Blog Post ' + uniqueNum));
    uniqueNum++;
  });

  // Heymarket Widget ADA compliance
  var checkIfExists = setInterval(function () { intervalHeymarket() }, 500);

  function intervalHeymarket() {
    var exists = document.getElementsByClassName("_3xVlCQbwTcQqgv2Zu2Cah6");

    console.log("exists");
    console.log(exists);

    if (exists) {
      clearInterval(checkIfExists);
      doStuff();
    }
  }

  function doStuff() {
    jQuery('._3xVlCQbwTcQqgv2Zu2Cah6').attr('aria-label', 'Chat with Pillar to Post Team Member');
    jQuery('._3gyTBhE88FJQ9u8DiBfClh').attr('aria-label', 'input field for mobile phone number');
    jQuery('._2frICvHXqjnmbdz5-MumJS').attr('aria-label', 'input field for email');
    jQuery('._3SVNncHswU2vO51hP_i2SB').attr('aria-label', 'input field for Name');
    jQuery('.l-_ClFxCm6wEj3FjO4Z8Z').attr('aria-label', 'checkbox to set contact to text message');
  }
});

/**
 *
 * Sometimes we need to comment this our because our
 * Gravity forms will not match
 *
 */

var newElement = document.querySelector(`div#gravityWrapper`);
if (typeof newElement != 'undefined' && newElement != null) {
  jQuery('.get-an-inspection').attr('data-toggle', 'getAnInspection');

  var d1 = document.getElementById('gform_6');
  if (typeof d1 != 'undefined' && d1 != null) {
  d1.insertAdjacentHTML(
    'afterbegin',
    `<div id="stepsSection">
		<h5 class="getAnInspectionHeader">Home Inspection Request</h5>
		<p class="small start-inspection">Start your inspection today.</p>
	</<div>`
  );
}

  // console.log(d1);
  // formating in below function is messed up, it is fixed below
  // var insertElement = document
  //   .querySelector(`div#gf_page_steps_6 .gf_step_clear`)
  //   .insertAdjacentHTML(
  //     'beforebegin',
  //     `<div id="oi_gf_checkmark" class="gf_step oi_gf_checkcontainer"><span class="gf_step_number gf_check"></span><span class="gf_step_label">Completed Form</span></div>`
  //   );

  var insertElement = document.querySelector('div#gf_page_steps_6');
  if (typeof insertElement != 'undefined' && insertElement != null) {
  insertElement.insertAdjacentHTML(
      'beforebegin',
      `<div id="oi_gf_checkmark" class="gf_step oi_gf_checkcontainer"><span class="gf_step_number gf_check"></span><span class="gf_step_label">Completed Form</span></div>`
    );
  }

  console.log(insertElement);
}

/*Resume*/

var newElement = document.querySelector(`div#homeBuyerLink`);
if (typeof newElement != 'undefined' && newElement != null) {
  let homebuyerlink = document.getElementById('homeBuyerLink');

  homebuyerlink.onclick = homeChange;

  function homeChange(e) {
    window.location = 'https://pillartopost.com/home-buyer/';
  }
}
var newElement = document.querySelector(`div#realEstateLink`);
if (typeof newElement != 'undefined' && newElement != null) {
  let realEstateLink = document.getElementById('realEstateLink');

  realEstateLink.onclick = realChange;

  function realChange(e) {
    window.location = 'https://pillartopost.com/real-estate-agents/';
  }
}

//ada 
jQuery('html > body > div:nth-child(1) > div:nth-child(3) > div:nth-child(4) > div:nth-child(2) > main > div > div > div:nth-child(4) > section > div > p > a').attr('alt', 'Khan Team Home inspectors');
jQuery('#post-2 > section > p:nth-child(14) > a').attr('alt', 'link to blog post');
jQuery('#kt-layout-id_6343e5-bc > div > div:nth-child(1) > div > div > figure > a').attr('alt', 'link to blog post');
jQuery('#kt-layout-id_6343e5-bc > div > div:nth-child(2) > div > div > figure > a').attr('alt', 'link to second blog post');
jQuery('#slick-slide00 > div > div > figure > div > div:nth-child(1) > img').attr('alt', 'pillar to post miranda team');


jQuery('button.kt-blocks-modal-link').attr('aria-label', 'PDF Popup Modal');
